// "Never set" checks for order fields that the database fills with a default.
// New leads are stored with Order Accepted = "Customer Canceled" and Part Status =
// "Not Available" before anyone has chosen anything. The backend only stamps
// orderProcessCompleteUpdatedAt / ShipmentTrackingUpdatedAt when that part of the
// lead is saved (ci-crm-backend Models/Lead.js pre-save hook), so an empty stamp
// plus no history row means the value is still the default. Display/pre-fill only.

const hasHistoryFor = (history, field) =>
    (history || []).some((entry) => entry?.field === field);

// Order Accepted (orderProcessComplete.partStatus) has never been chosen.
// A lead canceled from Advance Payment only gets Part Status "Customer Canceled
// Order" (no orderProcessComplete save) yet is on the cancel pages, so it counts
// as set.
export const isOrderDecisionUnset = (lead) =>
    !lead?.orderProcessCompleteUpdatedAt &&
    !hasHistoryFor(lead?.orderProcessCompleteHistory, 'orderProcessComplete.partStatus') &&
    lead?.ShipmentTracking?.partStatus !== 'Customer Canceled Order';

// Part Status (ShipmentTracking.partStatus) has never been chosen.
export const isPartStatusUnset = (lead) =>
    !lead?.ShipmentTrackingUpdatedAt &&
    !hasHistoryFor(lead?.ShipmentTrackingHistory, 'ShipmentTracking.partStatus');
